
























import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import AbstractField from './abstract-field/abstract-field';

@Component({
  name: 'bpc-search-input',
  components: {},
})
export default class SearchInput extends mixins(AbstractField) {
  // PROPS

  @Prop([String, Number]) readonly value: string | number;

  // DATA
  // LIFECYCLE
  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }

  // COMPUTED

  get model(): string | number {
    return this.value;
  }

  set model(val: string | number) {
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
    this.$emit('input', val);
  }

  get placeholderText(): string {
    return this.placeholder || this.$t('global.table.filter.search').toString();
  }

  clearSearchClicked() {
    this.model = '';
  }

  // METHODS

  onEnterKey() {
    this.$emit('enter-key');
  }

  // WATCHERS
}
